import Radium from "radium";
import * as React from "react";
import { connect } from "react-redux";

import { CustomCSS } from "@connect/Interfaces";
import { Icon } from "Components/Global/Common";
import { Colors } from "Components/Global/Constants";
import { RequestNameTypes } from "Components/Global/RequestNameModal";
import { setRequestNameModal } from "Data/Actions/UI/Modals";

const { lightGray, offWhite, primaryGreen, white } = Colors;

interface ICreateActionButtonProps {
	createAction: () => void;
}

const mapDispatchToProps = (dispatch) => ({
	createAction: () => dispatch(setRequestNameModal(true, RequestNameTypes.ACTION))
});

@Radium
export class CreateActionButton extends React.Component<ICreateActionButtonProps> {
	constructor(props: ICreateActionButtonProps) {
		super(props);
		this.styles = {
			outer: {
				color: lightGray,
				cursor: "pointer",
				background: offWhite,
				boxShadow: `0px 2px 10px ${lightGray}`,
				border: `1px solid ${white}`,
				borderRadius: 6,
				minHeight: 204,
				width: 560,
				margin: 10,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexDirection: "column",
				":hover": {
					color: white,
					background: primaryGreen,
					border: `1px solid ${primaryGreen}`
				}
			},
			icon: {
				marginBottom: 18
			}
		}
	}

	styles: CustomCSS;

	render() {
		const { outer, icon } = this.styles;
		return (
			<div
				style={ outer }
				onClick={ this.props.createAction }>
				<Icon
					name="plus-circle"
					size="small"
					style={ icon } />
				<p>New Action</p>
			</div>
		);
	}
}

export default connect(null, mapDispatchToProps)(Radium(CreateActionButton));
